<template>
  <b-card title="Chronologie Utilisateurs">
    <app-timeline>
      <!-- 12 INVOICES HAVE BEEN PAID -->
      <app-timeline-item>
        <div
          class="d-flex flex-sm-row flex-column flex-wrap justify-content-between mb-1 mb-sm-0"
        >
          <h6>12 Factures ont été payées</h6>
          <small class="text-muted">12 min passées</small>
        </div>
        <p>Factures payées à l'organisation.</p>
        <p class="mb-0">
          <b-img
            :src="require('@/assets/images/icons/pdf.png')"
            height="auto"
            width="20"
            class="mr-1"
          />
          <span class="align-bottom">facture.pdf</span>
        </p>
      </app-timeline-item>
      <app-timeline-item variant="warning">
        <div
          class="d-flex flex-sm-row flex-column flex-wrap justify-content-between mb-1 mb-sm-0"
        >
          <h6>Réunion bénéficiaires</h6>
          <small class="text-muted">45 min passées</small>
        </div>
        <p>Reunion du projet avec Coordo admin@10:15.</p>
        <b-media>
          <template #aside>
            <b-avatar :src="require('@/assets/images/avatars/8-small.png')" />
          </template>
          <h6>Admin FONER (Client)</h6>
          <p class="mb-0">Dev Project, NFINIC</p>
        </b-media>
      </app-timeline-item>
      <app-timeline-item
        variant="info"
        title="Créer un nouveau projet"
        subtitle="Ajouter de fichiers au dossier"
        time="2 jours passés"
      />
    </app-timeline>
  </b-card>
</template>

<script>
import { BCard, BImg, BMedia, BAvatar } from "bootstrap-vue";
import AppTimeline from "@core/components/app-timeline/AppTimeline.vue";
import AppTimelineItem from "@core/components/app-timeline/AppTimelineItem.vue";

export default {
  components: {
    BCard,
    BImg,
    BMedia,
    BAvatar,
    AppTimeline,
    AppTimelineItem,
  },
};
</script>

<style></style>
